import Image from 'next/image';

import { ImageCopyright } from '../../../design-system/components/image/copyright/ImageCopyright';
import { Ratio, RATIO } from '../../../design-system/components/ratio/Ratio';
import { DoublePictureSlice } from '../../../domains/Prismic/DestinationDetailDocument';
import { NullableSlice } from '../../../domains/Prismic/Utilities';

import style from './DoublePictures.module.css';

export type DoublePicturesProps = {
    doublePictures: NullableSlice<DoublePictureSlice>;
};

export function DoublePictures({ doublePictures }: DoublePicturesProps) {
    const { leftPicture, leftPictureCopyright, rightPicture, rightPictureCopyright } =
        doublePictures;

    return (
        <div className={style.wrapper}>
            <div className={style.leftColumn}>
                <Ratio ratio={RATIO['1/1']}>
                    {leftPicture?.url ? (
                        <Image
                            className={style.image}
                            alt={leftPicture.alt}
                            src={leftPicture.url}
                            unoptimized
                            fill
                        />
                    ) : null}

                    {leftPictureCopyright ? (
                        <ImageCopyright copyright={leftPictureCopyright} />
                    ) : null}
                </Ratio>
            </div>
            <div className={style.rightColumn}>
                <Ratio ratio={RATIO['1/1']}>
                    {rightPicture?.url ? (
                        <Image
                            className={style.image}
                            alt={rightPicture.alt}
                            src={rightPicture.url}
                            unoptimized
                            fill
                        />
                    ) : null}

                    {rightPictureCopyright ? (
                        <ImageCopyright copyright={rightPictureCopyright} />
                    ) : null}
                </Ratio>
            </div>
        </div>
    );
}
